import {Component, OnInit} from '@angular/core';
import {Order} from "../../shared/models/Order";
import {OrderService} from "../../core/http/order.service";
import {MatDialog} from "@angular/material/dialog";
import {OrderPosition} from "../../shared/models/OrderPosition";
import {
  ReceivedOrdersDetailsPopupComponent
} from "../received-orders-overview/received-orders-details-popup/received-orders-details-popup.component";
import {AuthService} from "../../core/auth/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-receipts-overview',
  templateUrl: './receipts-overview.component.html',
  styleUrls: ['./receipts-overview.component.scss']
})
export class ReceiptsOverviewComponent implements OnInit {
  receipts: Order[] = [];
  displayedColumns: string[] = ['tableNumber', 'orderNo', 'total', 'waiterName', 'printReceipt', 'created', 'printAgain'];

  constructor(private orderService: OrderService, private dialog: MatDialog, private authService: AuthService, private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    const waiterShiftGuid = this.authService.getWaiterShiftGuid();
    if (waiterShiftGuid) {
      this.orderService.getAllReceiptsOfShift(waiterShiftGuid).subscribe({
        next: (response) => {
          this.receipts = response;
        },
        error: (error) => {
          console.log(error);
        }
      });
    }
  }

  showOrderDetails(positions: OrderPosition[]): void {
    this.dialog.open(ReceivedOrdersDetailsPopupComponent, {
      data: { positions }, // Pass the positions data to the popup component
      width: '600px', // Set the width of the popup as per your preference
      panelClass: 'ordermate-dialog-panel'
    });
  }

  printReceiptAgain(receipt: Order): void {
    receipt.reprint = true;
    this.orderService.sendReceipt(receipt).subscribe(response => {
      console.log('successfully sent receipt');
      this._snackBar.open('Rechnung nochmal an Drucker gesendet', 'Schließen', {duration: 3000});
    });
  }
}
